const CLIENT_URL_PREFIX = 'client://linglupin'

function positionDetailUrl(id: string | number) {
  return `${CLIENT_URL_PREFIX}/C/positionDetail?id=${id}`
}

function organizationDetailUrl(id:string | number) {
  return `${CLIENT_URL_PREFIX}/C/organization?id=${id}`
}

function recruiterDetailUrl(id: string | number) {
  return `${CLIENT_URL_PREFIX}/C/recruitersDetail?id=${id}`
}

function changeIdentityUrl() {
  return `${CLIENT_URL_PREFIX}/changeIdentity`
}

function homepageUrl() {
  return `${CLIENT_URL_PREFIX}/homepage`
}

function settingUrl() {
  return `${CLIENT_URL_PREFIX}/setting`
}

function chatListUrl() {
  return `${CLIENT_URL_PREFIX}/chatList`
}

function mineUrl() {
  return `${CLIENT_URL_PREFIX}/mine`
}

export default {
  positionDetailUrl,
  organizationDetailUrl,
  recruiterDetailUrl,
  changeIdentityUrl,
  homepageUrl,
  settingUrl,
  chatListUrl,
  mineUrl
}